import React from "react";

import StatusIndicator from "components/school_money/history/StatusIndicator";

export default class DinnerBookingStatusIndicator extends React.Component {
  
  getStatusIndicatorProps() {
    switch (this.props.status) {
      case "MEAL":
        return { color: "#87BC49", label: "Paid Meal" };
      case "SANDWICH":
        return { color: "#895196", label: "Sandwiches" };
      case "FSM":
        return { color: "#134D68", label: "Free Meal" };
      case "NONE":
        return { color: "#B5CFDB", label: "No Dinner" };
      case "HOLIDAY":
        return { color: "#808080", label: "School Holiday" };
      case "UFSM":
        return { color: "#AC3524", label: "Infant Free Meal" };
      default:
        return {};
    }
  }
  
  render() {
    return <StatusIndicator {...this.getStatusIndicatorProps()} />;
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/history/DinnerBookingStatusIndicator.js